import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Lottie from 'react-lottie';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import CheckedAnimation from '../../../../animations/approved-checked-outline.json';
import CellularOrderDetails from '../CellularOrderDetails/CellularOrderDetails';
import {CellularModeEnum} from '../Esim/esimEnums';
import ThemedLottie from '../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../utilities/theme/ThemeColorEnum';

const callbackSuccess = (props) => {
  console.log('callbackSuccess==>props', props);
  return (
    <div className='callback-success'>
      {/* <Lottie options={{animationData: CheckedAnimation, loop: false}} width={200} height={200} /> */}
      <ThemedLottie animationData={CheckedAnimation} color={ThemeColorEnum.PRIMARY} width={200} height={200} loop={false} />
      <p>{props.successText}</p>
    </div>
  );
};

const OrderTop = (props) => {
  return (
    <Container>
      <Row>
        <Col className='congrats'>
          <Row>
            <Col className='congrats__title'>
            {(props.esim?.saleType == 'MIXED' || props.esim?.saleType == 'ESIMONLY') ? <Image src={require('./images/icon-esim.svg')} alt='light-icon' /> : <Image src={require('../images/icon-100-like.svg')} alt='light-icon' />}
            </Col>
          </Row>
          <Row className='congrats__text__container'>
            <Col className='congrats__text'>ההזמנה בוצעה בהצלחה!</Col>
          </Row>
          {props.esim?.saleType == 'MIXED' || props.esim?.saleType == 'ESIMONLY' ? (
            <Row className='congrats__text__container'>
              <Col className='congrats__esim_sub_title'>
                {props?.cellularOrderdetails?.isEsimNiudExistOnOrder
                  ? props?.esim?.esimData?.congratsEsimSaleAndNiudSubTitle?.value
                  : props?.esim?.esimData?.congratsEsimSaleOnlySubTitle?.value}
              </Col>
            </Row>
          ) : null}
          {props.saleInfo.saleType == 'cellular' && (
            <CellularOrderDetails esim={props.esim} selectedProducts={props.saleInfo.productsInfo.selectedProducts} />
          )}
          {props.saleInfo.productsInfo.baseProduct.isDisplaySimActivation ? (
            <div className='finish-banner'>
              <p>רוצים להתחיל את הניוד? לחצו על הכפתור ונעבור לתהליך הניוד הדיגיטלי שלנו</p>
              <div>
                <BtnSubmit
                  text='קדימה! בואו נפעיל את ה sim'
                  onclick={() => prepareUrl(props.saleInfo.productsInfo.selectedProducts[0].activateSimUrl, EpiContext)}
                />
              </div>
            </div>
          ) : null}
        </Col>
      </Row>
    </Container>
  );
};

const OrderBanner = (props) => {
  return (
    <Container>
      <Row>
        <Col md='12'>
          {props.isCallBackSuccess ? (
            callbackSuccess(props)
          ) : (
            <div className='finish-banner'>
              <div>
                <Row>
                  <Col>{props.title}</Col>
                </Row>
                <Row>
                  <Col>
                    <BtnSubmit text={props.btnText} onclick={props.click} />
                  </Col>
                </Row>
              </div>
              <div>{props.isCallBackError ? '' : null}</div>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export {OrderTop, OrderBanner};
